// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","685":"final"}[chunkId] || chunkId) + "." + {"132":"bfe973ef","142":"ad565228","594":"daa2aa52","685":"955b160d"}[chunkId] + ".css";
};